/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-17 16:11:58
 *
 *******************************************************/

import Style1 from 'src/assets/images/quick-view-cart/button-style/style-1.png';
import Style2 from 'src/assets/images/quick-view-cart/button-style/style-2.png';
import Style3 from 'src/assets/images/quick-view-cart/button-style/style-3.png';
import Style4 from 'src/assets/images/quick-view-cart/button-style/style-4.png';
import Style4DE from 'src/assets/images/quick-view-cart/button-style/style-4-de.png';
import Style5 from 'src/assets/images/quick-view-cart/button-style/style-5.png';
import Style6 from 'src/assets/images/quick-view-cart/button-style/style-6.png';
import Style6DE from 'src/assets/images/quick-view-cart/button-style/style-6-de.png';
import Popupcart from 'src/assets/images/quick-view-cart/tooltip/Cart display_Popupcart.gif';
import Sidecart from 'src/assets/images/quick-view-cart/tooltip/Cart display_Sidecart.gif';
import MiniPopup from 'src/assets/images/quick-view-cart/tooltip/Select option display_Mini popup.gif';
import Popup from 'src/assets/images/quick-view-cart/tooltip/Select option display_Popup.gif';

export const BUTTON_STYLES = [
  {
    value: 'bc-al-style1',
    label: 'AdminHTML.QuickViewCartSettings.Constants.buttonStyle1_Label',
    imageTooltip: { en: Style1 }
  },
  {
    value: 'bc-al-style2',
    label: 'AdminHTML.QuickViewCartSettings.Constants.buttonStyle2_Label',
    imageTooltip: { en: Style2 }
  },
  {
    value: 'bc-al-style3',
    label: 'AdminHTML.QuickViewCartSettings.Constants.buttonStyle3_Label',
    imageTooltip: { en: Style3 }
  },
  {
    value: 'bc-al-style4',
    label: 'AdminHTML.QuickViewCartSettings.Constants.buttonStyle4_Label',
    imageTooltip: { en: Style4, de: Style4DE }
  },
  {
    value: 'bc-al-style5',
    label: 'AdminHTML.QuickViewCartSettings.Constants.buttonStyle5_Label',
    imageTooltip: { en: Style5 }
  },
  {
    value: 'bc-al-style6',
    label: 'AdminHTML.QuickViewCartSettings.Constants.buttonStyle6_Label',
    imageTooltip: { en: Style6, de: Style6DE }
  }
];

export const QUICKVIEW_ADD_TO_CART_STYLES = {
  'bc-al-style1': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(61||66||70||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(255||255||255||1)',
    atcBtnTextColor: 'rgba(61||66||70||1)',
    atcBtnBorderColor: 'rgba(255||255||255||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style2': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(61||66||70||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(255||255||255||1)',
    atcBtnTextColor: 'rgba(61||66||70||1)',
    atcBtnBorderColor: 'rgba(255||255||255||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style3': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(0||0||0||1)',
    qvBtnTextColor: 'rgba(255||255||255||1)',
    qvBtnBorderColor: 'rgba(0||0||0||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(0||0||0||1)',
    atcBtnTextColor: 'rgba(255||255||255||1)',
    atcBtnBorderColor: 'rgba(0||0||0||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style4': {
    qvEnable: true,
    atcEnable: true,
    // qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    // qvBtnTextColor: 'rgba(61||66||70||1)',
    // qvBtnBorderColor: 'rgba(255||255||255||1)',
    // qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    // qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    // qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    // atcBtnBackgroundColor: 'rgba(0||0||0||1)',
    // atcBtnTextColor: 'rgba(255||255||255||1)',
    // atcBtnBorderColor: 'rgba(0||0||0||1)',
    // atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    // atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    // atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(49||55||61||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(34||34||34||1)',
    atcBtnTextColor: 'rgba(255||255||255||1)',
    atcBtnBorderColor: 'rgba(34||34||34||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style5': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(61||66||70||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(255||255||255||1)',
    atcBtnTextColor: 'rgba(61||66||70||1)',
    atcBtnBorderColor: 'rgba(255||255||255||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style6': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(61||66||70||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnTextColor: 'rgba(255||255||255||1)',
    atcBtnBorderColor: 'rgba(61||66||70||1)',
    atcBtnHoverBackgroundColor: 'rgba(255||255||255||1)',
    atcBtnHoverTextColor: 'rgba(61||66||70||1)',
    atcBtnHoverBorderColor: 'rgba(255||255||255||1)'
  }
};

export const SELECT_OPTION_IN_PRODUCT_ITEM_STYLES = [
  {
    value: 'popup',
    label: 'AdminHTML.QuickViewCartSettings.Constants.ajaxCartStyle01_Label',
    tooltipImage: Popup
  },
  {
    value: 'miniPopup',
    label: 'AdminHTML.QuickViewCartSettings.Constants.ajaxCartStyle02_Label',
    tooltipImage: MiniPopup
  }
];

export const AJAX_CART_STYLES = [
  {
    value: 'slide',
    label: 'AdminHTML.QuickViewCartSettings.Constants.cartDisplayType01_Label',
    tooltipImage: Sidecart
  },
  {
    value: 'popup',
    label: 'AdminHTML.QuickViewCartSettings.Constants.cartDisplayType02_Label',
    tooltipImage: Popupcart
  },
  {
    value: 'none',
    label: 'AdminHTML.QuickViewCartSettings.Constants.cartDisplayType03_Label',
    tooltipText: 'AdminHTML.QuickViewCartSettings.Constants.cartDisplayType03_Tooltip'
  }
];
